export default {
  methods: {
    rand() {
      return Math.random().toString(36).substr(2);
    },
    token() {
      return this.rand() + this.rand();
    },
    createSession() {
      const session = this.token();
      const vm = this;
      return new Promise((resolve) => {
        vm.$cookies.set("bci_session", {
          Date: new Date(),
          Score: 0,
          State: "Playing",
          Quiz: 1,
          Token: session,
          Answered: 0,
        });
        resolve(session);
      });
    },

    fetchSession() {
      return this.$cookies.get("bci_session");
    },
  },
};
